// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"6c24a644","99":"886e3c15","321":"6d9f90da","351":"dea954e0","376":"4b0e518b","392":"15023142","543":"a87535c6","567":"423e7d89","711":"f071e544","921":"bf3b6a1a","962":"a4c4d08d","963":"448e3653","994":"531f9ead"}[chunkId] + ".chunk.js";
};